module.exports = __webpack_public_path__ + "static/img/Icon.1d12d126.png";